import React from 'react';
import { useNavigate } from 'react-router-dom';
import asterisk from '../asserts/sun.png';
import './Asterisknav.css';

const AsteriskNav = ({ active, navRef }) => {
    const navigate = useNavigate();

    return (
        <nav className="hp-nav" ref={navRef} aria-label="Main Navigation">
            <div className="hp-nav-bg" style={{ backgroundImage: `url(${asterisk})` }} aria-hidden="true"></div>
            <p className="hp-nav-title">THE DESIGN SHOW</p>
            
            <button
                className={`hp-nav-icon hp-nav-icon--tl${active === 'events' ? ' hp-nav-icon--active' : ''}`}
                onClick={() => navigate('/events')}
                aria-label="View Events"
                aria-current={active === 'events' ? 'page' : undefined}
            >
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
            </button>
            <button
                className={`hp-nav-icon hp-nav-icon--tr${active === 'notifications' ? ' hp-nav-icon--active' : ''}`}
                onClick={() => navigate('/notification')}
                aria-label="View Notifications"
                aria-current={active === 'notifications' ? 'page' : undefined}
            >
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
            </button>
            <button
                className={`hp-nav-icon hp-nav-icon--ml${active === 'tickets' ? ' hp-nav-icon--active' : ''}`}
                onClick={() => navigate('/booking')}
                aria-label="Book Tickets"
                aria-current={active === 'tickets' ? 'page' : undefined}
            >
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"/>
                    <path d="M13 5v2M13 17v2M13 11v2"/>
                </svg>
            </button>
            <button
                className={`hp-nav-icon hp-nav-icon--mr${active === 'map' ? ' hp-nav-icon--active' : ''}`}
                onClick={() => navigate('/map')}
                aria-label="View Map"
                aria-current={active === 'map' ? 'page' : undefined}
            >
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
                    <line x1="9" y1="3" x2="9" y2="18"/>
                    <line x1="15" y1="6" x2="15" y2="21"/>
                </svg>
            </button>
            <button
                className={`hp-nav-icon hp-nav-icon--bot${active === 'home' ? ' hp-nav-icon--active' : ''}`}
                onClick={() => navigate('/home')}
                aria-label="Go to Home"
                aria-current={active === 'home' ? 'page' : undefined}
            >
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>
                    <polyline points="9 21 9 12 15 12 15 21"/>
                </svg>
            </button>
        </nav>
    );
};

export default AsteriskNav;